export const isUrlString = (str?: string) => str && /^http/i.test(str);
